import React, { useState } from 'react';
import { toast } from 'sonner';
import { createPaymentLink } from '../../lib/api';

const PACKAGES = [
  { id: 'classic', label: 'Classic — 1,000 AED' },
  { id: 'signature', label: 'Signature — 1,400 AED' },
  { id: 'custom', label: 'Custom amount' }
];

const empty = { client_name: '', client_email: '', package: 'classic', amount: '', note: '' };

export const PaymentLinkForm = ({ adminKey, onCreated }) => {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const set = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const link = await createPaymentLink(adminKey, {
        client_name: form.client_name,
        client_email: form.client_email || null,
        package: form.package,
        amount: form.package === 'custom' ? Number(form.amount) : null,
        note: form.note
      });
      onCreated(link);
      setForm(empty);
      toast.success('Payment link created');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not create the link');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="contact-form" data-testid="payment-link-form">
      <div className="form-group">
        <label className="form-label">Client name *</label>
        <input name="client_name" value={form.client_name} onChange={set} required className="form-input" placeholder="e.g. Sarah Ahmed" data-testid="link-client-name" />
      </div>
      <div className="form-group">
        <label className="form-label">Client email (optional)</label>
        <input type="email" name="client_email" value={form.client_email} onChange={set} className="form-input" placeholder="client@email.com" data-testid="link-client-email" />
      </div>
      <div className="form-group">
        <label className="form-label">Package *</label>
        <select name="package" value={form.package} onChange={set} className="form-select" data-testid="link-package">
          {PACKAGES.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
        </select>
      </div>
      {form.package === 'custom' && (
        <div className="form-group">
          <label className="form-label">Amount (AED) *</label>
          <input type="number" name="amount" min="1" step="1" value={form.amount} onChange={set} required className="form-input" placeholder="e.g. 500" data-testid="link-amount" />
        </div>
      )}
      <div className="form-group">
        <label className="form-label">Note (optional)</label>
        <input name="note" value={form.note} onChange={set} className="form-input" placeholder="e.g. Deposit for 12 July maternity session" data-testid="link-note" />
      </div>
      <button type="submit" disabled={saving} className="btn-submit" data-testid="link-create-btn">
        {saving ? 'Creating…' : 'Create payment link'}
      </button>
    </form>
  );
};
